import { Injectable } from '@angular/core';
import { IAppRequest } from '@app/app.interface';
import { TableService } from '@app/modules/table/table.service';
import { catchError, map, Observable, of, take } from 'rxjs';

/**
 * Основной сервис модуля Profiler
 */
@Injectable()
export class ProfilerService extends TableService {
    className: string = 'ProfilerService';
    url: string = '/profiler/front_profiler';

    /**
     * Получить количество медленных запросов
     */
    getItemsCount(): Observable<number> {
        const url = this.serverUrl + this.url + '/getItemsCount';
        return this.http.post<IAppRequest<number>>(url, {}, this._httpOptions).pipe(
            take(1),
            map((response) => {
                return response.data ?? 0;
            }),
            catchError(() => of(0)),
        );
    }
}
